import { styled } from "@mui/material/styles"
import { Tab as MuiTab, TabProps as MuiTabProps } from "@mui/material"

export type TabProps = MuiTabProps & {
    component?: React.ElementType
    to?: string
}

export const Tab = styled(MuiTab, {
    name: "tab",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})<TabProps>(({ theme }) => {
    const tabOverwrites = theme.overwrites?.components?.tabs ?? {}

    return {
        fontFamily: tabOverwrites?.font?.fontFamily ? tabOverwrites?.font?.fontFamily : theme.typography.fontFamily,
        textTransform: (tabOverwrites?.font?.textTransform as React.CSSProperties["textTransform"]) ?? "none",
        minWidth: 0,
        minHeight: 0,
        borderBottom: "3px solid lightgray",
        background: "none",
        position: "relative",

        "&:hover": {
            color: "#2e2e2e",
        },
        transition: theme.transitions.create(["font-size", "padding"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
        }),
        fontSize: theme.typography.fontSize - 2,
        padding: "6px 8px",
        [theme.breakpoints.up("lg")]: {
            fontSize: "1rem", // in the previous tab version the default fontsize was not set. due to this the 15px html fontsize has been inherited, so i had to add 1rem. i would prefer to set theme.typography.fontSize which is 16px
            padding: "11px 10px 4px 10px",
        },
    }
})
